import { Alpine } from '../../../../vendor/livewire/livewire/dist/livewire.esm';

import hasBlocksChanged from './hasBlocksChanged';
window.hasBlocksChanged = hasBlocksChanged;

import './alert'
import './confirm'
import './loading'
import './mobile'
import './modal'
import './transitionHeight'
import './smoothTransition'
import './responsive'
import './tooltip'
import './onResize'

import tableResponsive from './tableResponsive';

window.tableResponsive = tableResponsive

Alpine.data('tableResponsive', tableResponsive);
Alpine.data('hasBlocksChanged', hasBlocksChanged);
